<div class="joint-type">
  <i class="pi pi-bullseye"></i>

  <span>
    {{ jointNames }}
  </span>
</div>
